<template>
  <div class="goal-gambit-frame">
    <iframe
      :src="gameUrl"
      class="goal-gambit-iframe"
      title="Goal Gambit"
      frameborder="0"
      allow="autoplay; fullscreen; gyroscope; accelerometer; clipboard-write; encrypted-media"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import { getStoredMsisdn } from "@/functions/myBundleEntry";

export default {
  name: "GoalGambitGame",
  computed: {
    // Self-hosted Unity WebGL build in /public/goal-gambit.
    // The router guard guarantees we only reach this view with a msisdn. On a
    // My Bundle entry the signed params are stripped after validation, so fall
    // back to the stored server-validated msisdn.
    gameUrl() {
      const msisdn = new URLSearchParams(window.location.search).get("msisdn") || getStoredMsisdn() || "";
      const base = `${process.env.BASE_URL}game/index.html`;
      if (!msisdn) return base;
      const myBundle = sessionStorage.getItem("myBundle") === "true";
      return `${base}?msisdn=${encodeURIComponent(msisdn)}${myBundle ? "&myBundle=true" : ""}`;
    },
  },
};
</script>

<style scoped>
.goal-gambit-frame {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background: #000;
}

.goal-gambit-iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
